<template>
  <div class="article-page">
    <mt-header fixed :title="title" style="background:#3189FF;color:#ffffff;">
      <mt-button icon="back" slot="left" @click="goBack"></mt-button>
    </mt-header>

    <div v-if="article" class="scroll-wrapper">
      <iframe :src="article" frameborder="0"></iframe>
    </div>

    <div v-if="!article" class="scroll-wrapper">
      <agreement v-if="title=='果师兄用户协议'"></agreement>
      <privacy v-if="title=='隐私政策'"></privacy>
      <logout v-if="title=='注销用户'"></logout>
    </div>

  </div>
</template>

<script>
import Agreement from '@/static/guoshixiong/Agreement';
import Privacy from '@/static/guoshixiong/Privacy';
import Logout from '@/static/guoshixiong/Logout';
export default {
  
  data(){
    return{
      article: '',
      title: ''
    }
  },
  watch:{
   
  },
  methods:{
    goBack(){
      history.go(-1)
    }
  },
  components:{
    agreement: Agreement,
    privacy: Privacy,
    logout: Logout
  },
  mounted(){
  },
  created(){
    let info = this.$route.query
    this.article = info.url
    this.title = info.title
  }
}
</script>

<style lang="scss">
@import '../assets/css/base.scss';
</style>



// WEBPACK FOOTER //
// src/components/Article.vue